import { ArrowLeft, Grid3x3, ClipboardList, BarChart3 } from 'lucide-react'
import { useNavigate } from 'react-router-dom'

export function EvaluationModulePage() {
  const navigate = useNavigate()

  const modules = [
    {
      title: 'Grilles d\'évaluation',
      description: 'Créer et gérer vos grilles comportementales personnalisées',
      icon: Grid3x3,
      color: 'from-violet-500 to-purple-500',
      path: '/modules/evaluation/grids'
    },
    {
      title: 'Évaluer une classe',
      description: 'Lancer une session d\'évaluation comportementale',
      icon: ClipboardList,
      color: 'from-purple-500 to-indigo-500',
      path: '/modules/evaluation/evaluate'
    },
    {
      title: 'Résultats & Statistiques',
      description: 'Consulter l\'historique et analyser les tendances',
      icon: BarChart3,
      color: 'from-indigo-500 to-blue-500',
      path: '/modules/evaluation/results'
    }
  ]

  return (
    <div className="min-h-screen bg-gradient-to-br from-violet-50 via-purple-50 to-indigo-50">
      {/* Header */}
      <header className="bg-white/80 backdrop-blur-sm border-b border-gray-200 sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <button
            onClick={() => navigate('/')}
            className="flex items-center gap-2 text-gray-600 hover:text-gray-900 transition-colors"
          >
            <ArrowLeft className="w-5 h-5" />
            <span>Retour à l'accueil</span>
          </button>
        </div>
      </header>

      {/* Main Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="text-center mb-12">
          <div className="inline-flex items-center justify-center w-20 h-20 rounded-2xl bg-gradient-to-br from-violet-500 to-purple-500 mb-6">
            <svg
              className="w-10 h-10 text-white"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4"
              />
            </svg>
          </div>
          <h1 className="text-4xl font-bold text-gray-900 mb-4">
            Évaluation Comportementale
          </h1>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Créez et gérez les évaluations comportementales de vos élèves
          </p>
        </div>

        {/* Module Cards */}
        <div className="grid md:grid-cols-3 gap-6 max-w-6xl mx-auto">
          {modules.map((module) => {
            const Icon = module.icon
            return (
              <button
                key={module.path}
                onClick={() => navigate(module.path)}
                className="bg-white/80 backdrop-blur-sm rounded-2xl border border-gray-200 p-8 text-left hover:shadow-xl hover:scale-105 transition-all duration-200 group"
              >
                <div className={`inline-flex items-center justify-center w-14 h-14 rounded-xl bg-gradient-to-br ${module.color} mb-4 group-hover:scale-110 transition-transform`}>
                  <Icon className="w-7 h-7 text-white" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">
                  {module.title}
                </h3>
                <p className="text-gray-600">
                  {module.description}
                </p>
              </button>
            )
          })}
        </div>

        {/* API Status */}
        <div className="mt-12 text-center">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-green-50 border border-green-200 rounded-full text-sm text-green-700">
            <div className="w-2 h-2 rounded-full bg-green-500 animate-pulse"></div>
            <span>API backend opérationnelle</span>
          </div>
        </div>
      </div>
    </div>
  )
}
